import { atomWithStorage } from "jotai/utils";

export const serviceRegistration = atomWithStorage({
  avatar: null,
  location: null,
  certifications: [],
  portfolios: []
});
